import React from 'react';
import styles from './Hero.module.css';
import { Typewriter } from 'react-simple-typewriter';

export default function Hero() {
  return (
    <div className={styles.hero}>
      <div className={styles.heroPhoto}>
        <img
          src="Tsion.jpg"
          alt="Tsion Tesfaye"
          className={styles.img}
        />
      </div>
      <div className={styles.heroText}>
        <h1 className={styles.typewriterBox}>
          <Typewriter
            words={['Tsion Tesfaye']}
            loop={1}
            cursor
            cursorStyle='|'
            typeSpeed={80}
            deleteSpeed={50}
            delaySpeed={1000}
          />
        </h1>
        <p className={styles.typewriterBox}>
          <Typewriter
            words={['Passionate Full-Stack Developer crafting seamless digital experiences from front to back.']}
            loop={1}
            cursor
            cursorStyle='|'
            typeSpeed={40}
            deleteSpeed={20}
            delaySpeed={2000}
          />
        </p>
        <a href="#contact" className={styles.btnPrimary}>Contact Me</a>
      </div>
    </div>
  );
}
